import { notifications } from '@utils/notifications';

import Config from '@root/wrapperConfig';
import { getLocalStorageItem } from '../utils/getLocalStorageItem';

export default new (class APIrest {
  // Only RestAPI
  constructor() {
    this.server = Config.server.rest;
    this.version = 1;

    // if (location.href.indexOf('localhost') !== -1) {
    //   this.server = 'http://192.168.100.161:9002';
    // }

    this.server += `/api/site/v${this.version}/`;
  }

  getEcoCertificate = headerToken =>
    `${this.server}achivement.get/6/${headerToken}`;

  getSeoInfo = url => this.callMethod('meta.get', { url });

  getSearch = params => this.callMethod(`search.get?${params}`, {}, 'GET');

  getDeliveryInfo = (url, method) => this.callMethod2(url, method);

  callMethod2(url, method, headers = {}) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method,
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          ...headers
        }
      })
        .then(result => result.json())
        .then(result => {
          if (
            typeof result === 'undefined' ||
            result === null ||
            typeof result.errors !== 'undefined'
          ) {
            return Promise.reject(result.errors);
          }
          resolve(result);
        })
        .catch(e => {
          notifications(e);
          reject(e);
        });
    });
  }

  callMethod(url, data = {}, method = 'POST', headers = {}) {
    return new Promise((resolve, reject) => {
      // const requestFullUrl = url.slice(0, 4) === 'http' ? url : this.server + url;

      const params = {
        method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...headers
        }
      };
      if (method !== 'GET') {
        params.body = JSON.stringify(data);
      }

      fetch(this.server + url, params)
        .then(result => result.json())
        .then(result => {
          if (
            typeof result.data === 'undefined' ||
            result.data === null ||
            typeof result.data.errors !== 'undefined'
          ) {
            return Promise.reject(result.errors);
          }
          resolve(result.data);
        })
        .catch(e => {
          notifications(e);
          reject(e);
        });
    });
  }

  uploadImage(data = {}, url = 'https://api.delikateska.ru/api/file/upload') {
    const headerToken = getLocalStorageItem('headerToken');
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'X-People-Token': headerToken
        },
        body: data
      })
        .then(response => response.json())
        .then(result => {
          resolve(result);
        })
        .catch(e => {
          notifications(e);
          reject(e);
        });
    });
  }

  uploadFileByURL(
    urlFile = '',
    url = 'https://api.delikateska.ru/api/file/upload-by-link'
  ) {
    const headerToken = getLocalStorageItem('headerToken');
    const data = new URLSearchParams();
    data.append('link', urlFile);

    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'X-People-Token': headerToken,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      })
        .then(response => response.json())
        .then(result => {
          resolve(result);
        })
        .catch(e => {
          notifications(e);
          reject(e);
        });
    });
  }
})();
